<template>
<div>
  <b-spinner v-if="!history"></b-spinner>
  <div v-if="history && !history.length">No messages yet.</div>
  <b-card v-for="message in history" class="mt-3" :key="message.id">
    <p>{{message.outbound ? 'Outbound' : 'Inbound'}} Message</p>
    <p>{{message.message}}</p>
    <p>{{message.createdAt | moment('from')}}</p>
  </b-card>
</div>
</template>
<script>
import {
  ListSMS
} from '@/gql/members/SMS.gql';
export default {
  components: {
  },
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  apollo: {
    history: {
      query: ListSMS,
      variables() {
        return {
          number: this.member.phone
        }
      },
      result(data) {
        data.data.history.forEach((item) => {
          item.outbound = (item.toNumber == this.member.phone);
        });
        return data;
      }
    }
  }
}
</script>
